import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	margin: 0 auto;

	.company-site-content {
		background-color: ${vars.colorBackgroundContrast};
		width: 70%;
		padding: 6em;
		border-radius: 0.09em;
		margin-top: -10em;
	}
	.mobile-button-edit {
		display: none;
	}
	@media all and (max-width: ${vars.tabletL}) {
		.company-site-content {
			width: 100%;
			padding: 0 2em 2em 2em;
		}
		.mobile-button-edit {
			display: block;
			position: fixed;
			width: 100%;
			background-color: ${vars.colorBlack};
			padding: 1em 0;
			left: 0;
			bottom: 6.5em;
			z-index: 3;
		}
	}
	@media(max-width:323px) {
		.mobile-button-edit {
			bottom: 8em;
		}
	}
`;
